import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useProductAttributes from 'data-hooks/useProductAttributes';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPProductDescriptionUI from './PDPProductDescriptionUI';
import PDPProductDescriptionPlaceholder from './PDPProductDescriptionPlaceholder';
const PDPProductDescriptionInner = () => {
  const $ = _c(5);
  const {
    loading,
    error,
    data: t0
  } = useProductAttributes();
  const {
    description,
    dimensions,
    additional_attributes
  } = t0;
  if (error) {
    return null;
  }
  const t1 = additional_attributes?.showpiece_desc;
  let t2;
  if ($[0] !== description || $[1] !== dimensions || $[2] !== loading || $[3] !== t1) {
    t2 = <PDPProductDescriptionUI loading={loading} headline={description} dimensions={dimensions} description={t1} />;
    $[0] = description;
    $[1] = dimensions;
    $[2] = loading;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const PDPProductDescription = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPProductDescriptionPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPProductDescriptionInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPProductDescription;